import { useQuery } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'
import { useUserContext } from 'shared/hooks/useUserContext'

export interface GetPermissionsResponse {
  code: number
  data: string[]
}

export const getPermissions = async (accessToken: string) => {
  const response = await authApi.get<GetPermissionsResponse>(
    '/permissions/user-permissions',
    {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
  )

  return response.data.data
}

export const useGetPermissions = (options?: { customAccessToken?: string }) => {
  const user = useUserContext()
  const accessToken = options?.customAccessToken || user.user?.access_token

  // External-backend tokens are unknown to the auth service — the permissions
  // endpoint would 401 them, so the query stays disabled. Permissions for
  // such users arrive on the user object supplied by the remote.
  const isExternalAuth =
    !options?.customAccessToken && !!user.user?.isExternalAuth

  return useQuery({
    queryKey: ['permissions', accessToken],
    queryFn: () => getPermissions(accessToken!),
    staleTime: 1000 * 60 * 60,
    refetchInterval: 1000 * 60 * 10,
    enabled: !!accessToken && !isExternalAuth
  })
}
